<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
      <el-form-item label="选择公众号">
        <el-tag v-if="id!==null" style="margin-right:10px">{{ name }}</el-tag>
        <el-tag type="warning" @click="choose">选择公众号</el-tag>
      </el-form-item>
      <el-form-item label="open_id">
        <div v-for="item,index in formLabelAlign.arr" :key="index">
          <el-input v-model="item.open_id" style="margin-bottom:10px" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbitte">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择公众号"
      :visible.sync="choicedialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="40%"
    >
      <chooseaccount ref="wecawr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import chooseaccount from './chooseaccount.vue'
import { oatestingcreate, oatestingupdate } from '@/api/sourceMaterial.js'
export default {
  components: {
    chooseaccount
  },
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        arr: [
          {
            open_id: ''
          },
          {
            open_id: ''
          }
        ]
      },
      type: null,
      choicedialogVisible: false,
      name: '',
      id: null,
      chaunarr: [],

      ids: null// 编辑的id

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      this.type = type
      if (type === 2) {
        this.ids = item.id
        this.name = item.account_name
        this.id = item.app_id
        this.chaunarr = item.test_open_ids
        this.formLabelAlign.arr = []
        item.test_open_ids.forEach((res) => {
          this.formLabelAlign.arr.push({
            open_id: res
          })
        })
      }
      console.log(this.formLabelAlign.arr)
    },
    choose() {
      this.choicedialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.wecawr.send()
      }, 100)
    },
    callback(item) {
      this.choicedialogVisible = false
      this.name = item.account_name
      this.id = item.app_id
    },
    sumbitte() {
      if (this.id === null) {
        this.$message.error('请选择公众号')
        return
      }
      const keybools = this.formLabelAlign.arr.every((item, index, array) => {
        return item.open_id !== ''
      })
      if (keybools === false) {
        this.$message.error('请填写open_id')
        return
      }
      if (this.type === 1) {
        this.chaunarr = []
        this.formLabelAlign.arr.forEach((res) => {
          this.chaunarr.push(res.open_id)
        })
        oatestingcreate({
          app_id: this.id,
          test_open_ids: this.chaunarr
        }).then((res) => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
          console.log('res', res)
        })
        console.log('新增')
      } else {
        this.chaunarr = []
        this.formLabelAlign.arr.forEach((res) => {
          this.chaunarr.push(res.open_id)
        })
        oatestingupdate({
          app_id: this.id,
          test_open_ids: this.chaunarr,
          id: this.ids
        }).then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
          console.log('res', res)
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
